import { Subnav } from '@monorepo/shared/componentsV2/Subnav';
import DatabaseIcon from '@svg/database.svg';
import DocumentsIcon from '@svg/documents.svg';
import NotesIcon from '@svg/notes.svg';
import TableIcon from '@svg/table.svg';
import TreeStructureIcon from '@svg/tree-structure.svg';
import { useFeatureFlags } from 'mapistry-shared/api';
import React, { useMemo } from 'react';

const edpSubnavOptions = [
  { href: 'logs', label: 'Logs', icon: <TableIcon /> },
  { href: 'resource-types', label: 'Resources', icon: <DatabaseIcon /> },
  { href: 'workflows', label: 'Workflows', icon: <TreeStructureIcon /> },
];

export function DataSetupSubnav() {
  const { isData2Enabled } = useFeatureFlags();

  const subnavOptionsBasedOnFeatureFlags = useMemo(
    () => [
      ...(isData2Enabled
        ? [
            {
              title: 'Environmental Data',
              options: edpSubnavOptions,
              ariaLabel: 'Environmental Data',
            },
          ]
        : []),
      {
        options: [
          { href: 'forms', label: 'Forms', icon: <NotesIcon /> },
          { href: 'documents', label: 'Documents', icon: <DocumentsIcon /> },
        ],
        ariaLabel: 'Forms and Documents',
      },
    ],
    [isData2Enabled],
  );

  return (
    <Subnav label="Setup" optionSections={subnavOptionsBasedOnFeatureFlags} />
  );
}
